/**
 * @flow
 */
'use strict';

export const complaintLocationCodes = [
{"code":"Left eye"},
{"code":"Right eye"},
{"code":"Both eyes"},
{"code":"Left temple"},
{"code":"Right temple"},
{"code":"Both temples"},
{"code":"Across forehead"},
{"code":"Back of head"},
{"code":"Top of head"},
]
